import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Component
 *
 * Paso a crear:
 */

@Component({
  selector: 'comp-progress-bar',
  templateUrl: 'progress-bar.html',
})
export class ProgressBarPage {
  @Input() percetage: string = '100';

  constructor(public navCtrl: NavController,
    public navParams: NavParams) {

  }

  styleIcon() {

    let styles = {
      'width': this.percetage + '%',
    };

    return styles;

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/progress-bar/progress-bar.ts